module.exports = __webpack_public_path__ + "img/icon5.87946201.png";